import { FaMapMarkerAlt, FaBriefcase, FaCheck } from 'react-icons/fa';
import { Container, PageHero, Reveal, SectionHead } from '../components/ui';

const jobs = [
  {
    title: 'Industrial Automation Engineer',
    location: 'Kolkata, West Bengal',
    department: 'Engineering',
    description:
      'Lead and design automation solutions across projects including automation, IoT and energy management systems. You will carry out site inspections, work with stakeholders across the organisation, manage vendors, create and validate technical documents, and take part in project execution, commissioning and training of junior engineers.',
    responsibilities: ['Site inspections & solution design', 'Stakeholder communication', 'Vendor management', 'Technical documentation', 'Project commissioning & installation'],
    requirements: ['2-4 years of experience', 'PLC & HMI programming', 'AutoCAD', 'VFD programming', 'Reasoning & logical thinking', 'Communication skills'],
    download: 'https://docs.google.com/document/d/1jk62r6yDAFSNteXc-gVKaFN8ISZn63OCd_lYMxFv7f0/edit?tab=t.0',
    apply: 'https://docs.google.com/forms/d/e/1FAIpQLScY9CgOFSWfMQ40-D-4eVKztUH-293mJluk9Md5tXqazBmg9A/viewform?usp=header',
  },
];

const List = ({ title, items }) => (
  <div>
    <h4 className="font-mono text-xs uppercase tracking-widest text-primary mb-3">{title}</h4>
    <ul className="space-y-2">
      {items.map((i) => (
        <li key={i} className="flex items-start gap-2 text-slate-700"><FaCheck className="mt-1.5 text-primary shrink-0" size={11} />{i}</li>
      ))}
    </ul>
  </div>
);

const CareerPage = () => (
  <>
    <PageHero
      eyebrow="Careers"
      title="Build the systems that keep industry moving."
      text="We're looking for curious engineers who like working on real plants with real equipment, and growing with the team."
    />
    <section className="py-20 md:py-24 bg-mist">
      <Container>
        <Reveal><SectionHead eyebrow="Open positions" title={`${jobs.length} role${jobs.length > 1 ? 's' : ''} open right now`} /></Reveal>
        <div className="mt-10 space-y-6">
          {jobs.map((job) => (
            <Reveal key={job.title}>
              <article className="rounded-2xl bg-white border border-slate-200 p-7 md:p-10">
                <h3 className="font-display font-bold text-2xl md:text-3xl text-secondary">{job.title}</h3>
                <p className="mt-3 flex flex-wrap gap-x-6 gap-y-1 text-sm text-slate-500">
                  <span className="inline-flex items-center gap-2"><FaMapMarkerAlt className="text-primary" />{job.location}</span>
                  <span className="inline-flex items-center gap-2"><FaBriefcase className="text-primary" />{job.department}</span>
                </p>
                <p className="mt-5 text-slate-600 max-w-3xl">{job.description}</p>
                <div className="mt-8 grid md:grid-cols-2 gap-8">
                  <List title="Responsibilities" items={job.responsibilities} />
                  <List title="Requirements" items={job.requirements} />
                </div>
                <div className="mt-9 flex flex-wrap items-center gap-4">
                  <a href={job.apply} target="_blank" rel="noopener noreferrer" className="rounded-full bg-primary hover:bg-[#0aa0ee] text-white font-semibold px-7 py-3 transition">Apply now</a>
                  <a href={job.download} target="_blank" rel="noopener noreferrer" className="rounded-full border border-secondary/30 text-secondary hover:bg-secondary hover:text-white font-semibold px-7 py-3 transition">Download job description</a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  </>
);

export default CareerPage;
